import {createSelector} from 'reselect';

export const reviewStaticDataHNSelector = state => state.review?.descblockResponse?.cdata?.HotelName;
export const reviewStaticDataAddressSelector = state => state.review?.descblockResponse?.cdata?.HotelAddress;
export const reviewStaticDataImageSelector = state => state.review?.descblockResponse?.cdata?.Image;
export const reviewStaticDataCheckinDisplayDate = state => state.review?.descblockResponse?.cdata?.checkin_display;
export const reviewStaticDataCheckoutDisplayDate = state => state.review?.descblockResponse?.cdata?.checkout_display;

export const reviewStaticInclusionsSelector = state => state.review?.descblockResponse?.cdata?.Inclusions || [];

export const revieStaticDataCheckinTime = state => state.review?.descblockResponse?.cdata?.checkintime;
export const revieStaticDataCheckoutTime = state => state.review?.descblockResponse?.cdata?.checkouttime;

export const reviewPagePricing = state => state.review?.descblockResponse?.cdata?.fb_list || [];
export const reviewPageWallet = state => state.review?.descblockResponse?.cdata?.wb_list || [];
export const travellerDetails = state => state.review?.traveller;

export const userVerified = state => state.review?.userVerified;
export const otpVerificationDone = state => state.review?.otpVerificationDone;

const appliedPromocode = state => state.review?.descblockInput?.code || '';
const promoMessage = state => state.review?.descblockResponse?.promo_message;
const promoShortMessage = state => state.review?.descblockResponse?.short_message;
const ifPromoApplied = state => state.review?.descblockResponse?.cdata?.promo_applied;
const promoList = state => state.review?.descblockResponse?.cdata?.applicablepromolist;
const isBusinessProfile = state => state.review?.traveller?.businessProfile;
const noOfAdults = state => state.review?.descblockResponse?.cdata?.noofAdults || 0;
const noofChildren = state => state.review?.descblockResponse?.cdata?.noofChildren || 0;
const grandTotal = state => state.review?.descblockResponse?.cdata?.grandtotal;
const finalAmount = state => state.review?.descblockResponse?.cdata?.aftrpromototaldisplay;
const roomType = state => state.review?.descblockResponse?.cdata?.RoomTypeName;
const numberOfRooms = state => state.review?.descblockResponse?.cdata?.noofRooms || 0;
const numberOfNights = state => state.review?.descblockResponse?.cdata?.noofNights || 0;
const freeCancelDate = state => state.review?.descblockResponse?.cdata?.vendor_fcdt_org || '';
const hotelStars = state => state.review?.descblockResponse?.cdata?.star || 0;
const descBlockCdata = state => state.review?.descblockResponse?.cdata;
const descBlockOfferKey = state => state.review?.descblockResponse?.offer_key || 0;
const descBlockSuccess = state => state.review?.descblockResponse?.success;
const descBlockInputVendor = state => state.review?.descblockInput?.v || 'v3';
const descBlockInput = state => state.review?.descblockInput;

const paymentResponseSuccess = state => state.review.paymentsData.data ? true : false;
const payMode = state => state.review?.descblockResponse?.cdata?.pay_mode;
const paymentType = state => state.review?.descblockResponse?.cdata?.payment_type;
const hotelsPaymentLoading = state => state.review?.paymentsData?.loading;
const descblockLoading = state => state.review?.descblockResponse?.loading;
// const bookingDetails = state => state.review?.paymentsData?.bookdetails;
const bookingDetails = state => state.review?.paymentsData?.data;
const paymentModuleOpen = state => state.review?.paymentOpen;
const OTPVerifyFlag = state => state.review?.descblockResponse?.cdata?.otp_verify || false;
const totalCredits = state => state.review?.descblockResponse?.cdata?.total_credits || 0;

const addOnList = state => state.review?.descblockResponse?.cdata?.addon_list || [];
const earlycheckin = state => state.review?.earlycheckin;
const extraMessages = state => state.review?.descblockResponse?.cdata?.extramsg || [];
const panList = state => state.review?.descblockResponse?.cdata?.pan_list;
const panIsMandatory = state => state.review?.descblockResponse?.cdata?.user_pan_config_data?.is_mandatory;
const enablePanCard = state => state.review?.descblockResponse?.cdata?.user_pan_config_data?.enable_pan_card;
const countryCodes = state => state.review?.countryCodes || [];
const descBlockResponse = state => state.review?.descblockResponse?.cdata?.aftrpromototal || '';
const descBlockFwd = state => state.review?.descblockResponse?.cdata?.fwdParams || [];

const internationalCurrency = state =>
  state.review?.descblockResponse?.cdata?.farebreakup?.unconverteddata?.Currency || '';
const internationalTotalAmount = state =>
  state.review?.descblockResponse?.cdata?.farebreakup?.unconverteddata?.totalRoomRent || 0;

const reviewPageTotalApplicablePGAmount = state => state.review?.descblockResponse?.cdata?.farebreakup?.pgRoomRent || 0;
const reviewPageTotalApplicableWalletAmount = state => state.review?.descblockResponse?.cdata?.farebreakup?.walletRoomRent || 0;
const reviewPageTotalWalletAmount = state => state.review?.descblockResponse?.cdata?.farebreakup?.wallet_amount || 0;

const hotelsPolicy = state => state.review?.policies?.hotelPolicy ? state.review?.policies?.hotelPolicy : state.review?.policies?.hotel_policy_text || [];
const cancellationPolicy = state => state.review?.policies?.cancelPolicy ?  state.review?.policies?.cancelPolicy : state.review?.policies?.cancellation_text || [];
const additionalHotelsPolicy = state => state.review?.policies?.additional_hotel_policy || {};
// const gdsHotelPolicy = state => state.review?.policies?.hotel_policy_text || [];
// const gdsCancellationText = state => state.review?.policies?.cancellation_text || [];

const thingsYoushouldKnow = createSelector(
  additionalHotelsPolicy,
  additionalHotelsPolicy => additionalHotelsPolicy['Hotel Policy'] || [],
);
const policiesLoading = state => state.review?.policies?.loading;

const checkinTimeList = state => state.review?.descblockResponse?.cdata?.checkin_time_array || [];


export const countryCodesSelector = createSelector(countryCodes, item => item);

export const descBlockSelector = createSelector(descBlockResponse, item => item);
export const descBlockFwdSelector = createSelector(descBlockFwd, item => item);

export const descblockInputSelector = createSelector(descBlockInput, item => item);

export const checkinTimeListSelector = createSelector(checkinTimeList, item => item);

export const hotelAreaReviewInput = createSelector(
  descblockInputSelector,
  item => item.hotelArea || '',
);

export const cityCodeReviewInput = createSelector(
  descblockInputSelector,
  item => item.cityCode || '',
);

export const roomDetailsSelector = createSelector(
  roomType,
  numberOfRooms,
  freeCancelDate,
  hotelStars,
  addOnList,
  extraMessages,
  hotelsPolicy,
  cancellationPolicy,
  thingsYoushouldKnow,
  // gdsHotelPolicy,
  // gdsCancellationText,
  (
    roomType,
    numberOfRooms,
    freeCancellationDate,
    hotelStars,
    addOnList,
    extraMessages,
    hotelsPolicy,
    cancellationPolicy,
    thingsYoushouldKnow,
    // gdsHotelPolicy,
    // gdsCancellationText,
  ) => ({
    roomType,
    numberOfRooms,
    freeCancellationDate,
    addOnList,
    hotelStars,
    extraMessages,
    hotelsPolicy,
    cancellationPolicy,
    thingsYoushouldKnow,
    // gdsHotelPolicy,
    // gdsCancellationText,
  }),
);

export const totalPaxSelector = createSelector(
  noOfAdults,
  noofChildren,
  (noOfAdults, noofChildren) => noOfAdults + noofChildren,
);

export const roomPaxDetails = createSelector(
  noOfAdults,
  noofChildren,
  numberOfRooms,
  numberOfNights,
  (noOfAdults, noofChildren, numberOfRooms, numberOfNights) => ({
    totalPax: noOfAdults + noofChildren,
    numberOfRooms,
    numberOfNights,
  }),
);

export const isBusinessProfileSelector = createSelector(isBusinessProfile, item => item);

export const appliedPromoSelector = createSelector(
  appliedPromocode,
  promoMessage,
  promoShortMessage,
  ifPromoApplied,
  (appliedPromocode, promoMessage, promoShortMessage, ifPromoApplied) => ({
    appliedPromocode,
    promoMessage,
    promoShortMessage,
    promoApplied: ifPromoApplied || false,
  }),
);

export const promoListSelector = createSelector(promoList, item => item);

export const reviewStaticDataSelector = createSelector(
  reviewStaticDataHNSelector,
  reviewStaticDataAddressSelector,
  reviewStaticDataImageSelector,
  hotelStars,
  (hn, address, hotelImage, hotelStars) => ({
    hn,
    address,
    hotelImage,
    hotelStars,
  }),
);

export const reviewCheckinCheckoutDetailsSelector = createSelector(
  reviewStaticDataCheckinDisplayDate,
  reviewStaticDataCheckoutDisplayDate,
  revieStaticDataCheckinTime,
  revieStaticDataCheckoutTime,
  (checkinDisplayDate, checkoutDisplayDate, checkinDisplayTime, checkoutDisplayTime) => ({
    checkinDisplayDate,
    checkoutDisplayDate,
    checkinDisplayTime,
    checkoutDisplayTime,
  }),
);

export const reviewPagePricingSelector = createSelector(
  reviewPagePricing,
  reviewPageWallet,
  grandTotal,
  finalAmount,
  internationalCurrency,
  internationalTotalAmount,
  reviewPageTotalApplicableWalletAmount,
  (
    reviewPagePricing,
    reviewPageWallet,
    grandTotal,
    finalAmount,
    internationalCurrency,
    internationalTotalAmount,
    reviewPageTotalApplicableWalletAmount
  ) => ({
    reviewPagePricing,
    reviewPageWallet,
    grandTotal,
    finalAmount,
    internationalCurrency,
    internationalTotalAmount,
    reviewPageTotalApplicableWalletAmount
  }),
);

export const reviewPagePaymentBreakupSelector = createSelector(
  reviewPageTotalApplicablePGAmount,
  reviewPageTotalApplicableWalletAmount,
  reviewPageTotalWalletAmount,
  (
    reviewPageTotalApplicablePGAmount,
    reviewPageTotalApplicableWalletAmount,
    reviewPageTotalWalletAmount
  ) => ({
    reviewPageTotalApplicablePGAmount,
    reviewPageTotalApplicableWalletAmount,
    reviewPageTotalWalletAmount
  })
);

export const totalPGAmountSelector = createSelector(reviewPageTotalApplicablePGAmount, item => item);

const userInfoSelector = state => state.user?.userInfo || {};
export const userInfoReview = createSelector(userInfoSelector, item => {return {'email' : item?.email?.value || item?.secondary_email?.value || '',
'mobile' : item?.mobile_number?.value || item?.secondary_mobile?.value || ''}})

export const travellerDetailsSelector = createSelector(travellerDetails, item => item);

export const paymentsDataSelector = createSelector(
  descBlockSuccess,
  paymentResponseSuccess,
  payMode,
  paymentType,
  hotelsPaymentLoading,
  bookingDetails,
  descBlockCdata,
  descBlockOfferKey,
  descBlockInputVendor,
  (
    descBlockSuccess,
    paymentResponseSuccess,
    payMode,
    paymentType,
    hotelsPaymentLoading,
    bookingDetails,
    descBlockCdata,
    descBlockOfferKey,
    descBlockInputVendor,
  ) => ({
    descBlockSuccess,
    paymentResponseSuccess,
    payMode,
    paymentType,
    hotelsPaymentLoading,
    bookingDetails,
    descBlockCdata,
    descBlockOfferKey,
    vendor: descBlockInputVendor || 'v3',
  }),
);

export const isPahSelector = createSelector(payMode, paymentType, (payMode, paymentType) => ({
  isPah: (paymentType === 2 && payMode !== 3) || payMode === 5,
  isPahCC: paymentType === 2 && payMode === 3,
}));

export const paymentModuleOpenSelector = createSelector(paymentModuleOpen, item => item);

export const descblockLoadingSelector = createSelector(descblockLoading, item => item);

export const hotelsPaymentLoadingSelector = createSelector(hotelsPaymentLoading, item => item);

export const loadersStatusSelector = createSelector(
  descblockLoadingSelector,
  hotelsPaymentLoadingSelector,
  (descblockLoading, hotelsPaymentLoading) => ({descblockLoading, hotelsPaymentLoading}),
);

export const earlycheckinSelector = createSelector(earlycheckin, item => item);

export const needPanSelector = createSelector(
  panIsMandatory,
  enablePanCard,
  (panIsMandatory, enablePanCard) => (panIsMandatory && enablePanCard && true) || false,
);

export const panListSelector = createSelector(panList, item => item);

export const isVerificationRequiredSelector = createSelector(OTPVerifyFlag, (item) => item);

export const userVerifiedSelector = createSelector(userVerified, item => item);

export const otpVerificationDoneSelector = createSelector(otpVerificationDone, item => item);
